import { GeoFeature, GeoParams } from '@/types';

export async function getGeoData(params: GeoParams) {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CDN_ENDPOINT}/${params.tenant}/geojson/${params.geoId}.geojson`,
        {
            next: {
                tags: [`${params.tenant}-geo-${params.geoId}`],
                revalidate: 60 * 15,
            },
        }
    );

    if (!response.ok) {
        if (response.status === 404 || response.status === 403) {
            return null;
        }
        throw new Error(response.statusText);
    }

    const json = (await response.json()) as GeoFeature;

    return json;
}
